import { render } from "./UsabillaInPageComponent.vue?vue&type=template&id=7db8e7fb&ts=true"
import script from "./UsabillaInPageComponent?vue&type=script&lang=ts"
export * from "./UsabillaInPageComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__